import { queryOptions } from "@tanstack/react-query";
import { fetchBrandBrain, fetchBrandBrainAvailability } from "@/features/brand-brain/api/brand-brain.api";

export const brandBrainKeys = {
  all: ["brand-brain"] as const,
  tenant: (tenantId: string) => ["brand-brain", tenantId] as const,
  availability: ["brand-brain", "availability"] as const,
} as const;

export function brandBrainQueryOptions(tenantId: string) {
  return queryOptions({
    queryKey: brandBrainKeys.tenant(tenantId),
    queryFn: () => fetchBrandBrain(),
    enabled: tenantId.length > 0,
    retry: false,
    meta: { skipGlobalError: true },
  });
}

/** Treat anything but a loaded `writesEnabled: true` as read-only. */
export function brandBrainAvailabilityQueryOptions() {
  return queryOptions({
    queryKey: brandBrainKeys.availability,
    queryFn: fetchBrandBrainAvailability,
    staleTime: Infinity,
    retry: false,
    meta: { skipGlobalError: true },
  });
}
